import { gql } from '@apollo/client';

export const LIMIT = 5;

export const GET_BANNERS = gql`
  query Projects(
    $companyId: ID!, 
    $status: ProjectStatusEnum!, 
    $testType: TestTypeEnum!, 
    $userId: ID!,
    $limit: Int!
  ) {
    projects(
      companyId: $companyId, 
      submittedAvailabilities: false, 
      status: $status, 
      testType: $testType, 
      userId: $userId, 
      dismissedBanner: false,
      limit: $limit,
    ) {
      id
      name
      dismissedBanner
    }
  }
`;

export const DISMISS_BANNER = gql`
  mutation DismissBanner($projectId: ID!) {
    dismissBanner(projectId: $projectId) {
      projectId 
      dismissedBanner
    }
  }
`;
